import React from 'react';
import PropTypes from 'prop-types';
import { apis } from '../api/index.js';
import { Form, Input, Button, Checkbox, message } from 'antd';
import { Modal, Radio } from 'antd';

const { TextArea } = Input;

class AIEvaluate extends React.Component {
  static propTypes = {
    visible: PropTypes.bool.isRequired,
    detail: PropTypes.object.isRequired,
    onCancel: PropTypes.func.isRequired,
    form: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      commentValue: undefined,
    };
  }

  componentDidUpdate(prev) {
    const { visible } = this.props;
    if (prev.visible !== visible && visible) {
      this.props.form.setFieldsValue({
        evaluate: '',
        resultCode: [],
        details: '',
      });
      this.setState({ commentValue: undefined });
    }
  }

  onSave = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const { diagId, type } = this.props.detail;
        const post = {
          diagId,
          type,
          resultCode: (values.resultCode || []).join(','),
          details: values.details,
        };

        apis.reviewNB(post).then(res => {
          if (res.code === '0') {
            message.success('评价成功');
            this.props.onCancel(true);
          } else message.error(res.message);
        });
      }
    });
  };

  commentChange = e => {
    this.setState({ commentValue: e.target.value });
  };
  render() {
    const { getFieldDecorator } = this.props.form;
    const { commentValue } = this.state;

    const comment1 = [
      { label: '标画准确、全面', value: '1' },
      { label: '主要病灶标画准确', value: '2' },
      { label: '诊断意见准确', value: '3' },
    ];
    const comment2 = [
      { label: '标画错误', value: '-1' },
      { label: '主要病灶未标画', value: '-2' },
      { label: '描述不准确', value: '-3' },
      { label: '描述不全面', value: '-4' },
      { label: '其它原因', value: '-5' },
      { label: '部分不采纳', value: '-7' },
      { label: '影像阴性', value: '-6' },
    ];
    return (
      <Modal
        visible={this.props.visible}
        title="AI结果评价"
        centered
        width={'600px'}
        height={'500px'}
        onCancel={() => this.props.onCancel()}
        footer={[
          <Button
            key={0}
            onClick={() => this.props.onCancel()}
            className="btn-cancel"
            type="default"
          >
            取消
          </Button>,
          <Button
            key={1}
            onClick={e => this.onSave(e)}
            type="primary"
            className="btn-ok"
          >
            提交
          </Button>,
        ]}
      >
        <Form className="evaluate-form">
          <Form.Item label="评价结果" colon={false}>
            {getFieldDecorator('evaluate', {
              rules: [{ required: true, message: '请选择评价结果' }],
            })(
              <Radio.Group onChange={this.commentChange}>
                <Radio value={true}>采纳</Radio>
                <Radio value={false}>不采纳</Radio>
              </Radio.Group>
            )}
          </Form.Item>
          {[true, false].includes(commentValue) && (
            <Form.Item label="评价结果理由" colon={false}>
              {getFieldDecorator('resultCode', {
                rules: [{ required: true, message: '请选择评价理由' }],
              })(
                <Checkbox.Group
                  className="checkbox-inline"
                  options={commentValue ? comment1 : comment2}
                />
              )}
            </Form.Item>
          )}
          {commentValue === false && (
            <Form.Item label="原因" colon={false}>
              {getFieldDecorator('details', {})(
                <TextArea className="auto-input" placeholder="请输入详情原因" />
              )}
            </Form.Item>
          )}
        </Form>
      </Modal>
    );
  }
}

export default Form.create()(AIEvaluate);
